module.exports = __webpack_public_path__ + "img/cycle-4_b.fb411117.png";